import { Dialog, Box, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'

const DeleteAnnouncementModal = ({ open, onClose, onConfirm, announcementTitle }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '6.5px',
          p: '32px',
          width: '100%',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        {/* Warning icon */}
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
            <path d="M2.08203 43.7493L24.9987 4.16602L47.9154 43.7493H2.08203ZM24.9987 37.4993C25.589 37.4993 26.0841 37.2993 26.4841 36.8993C26.8841 36.4993 27.0834 36.0049 27.082 35.416C27.0806 34.8271 26.8806 34.3327 26.482 33.9327C26.0834 33.5327 25.589 33.3327 24.9987 33.3327C24.4084 33.3327 23.914 33.5327 23.5154 33.9327C23.1168 34.3327 22.9168 34.8271 22.9154 35.416C22.914 36.0049 23.114 36.5 23.5154 36.9014C23.9168 37.3028 24.4112 37.5021 24.9987 37.4993ZM22.9154 31.2493H27.082V20.8327H22.9154V31.2493Z" fill="#E2B93B"/>
        </svg>

        {/* Title */}
        <Typography variant="h5"
          sx={{ 
            fontWeight: 600, 
            textAlign: 'center', 
            color: 'text.primary' 
        }}
        >
          Delete announcement?
        </Typography>

        {/* Body */}
        <Typography
          sx={{ textAlign: 'center', color: 'text.primary', fontSize: '16px', lineHeight: 1.7 }}
        >
          Are you sure you want to delete{' '}
          <Box component="span" sx={{ fontWeight: 700 }}>
            &ldquo;{announcementTitle}&rdquo;
          </Box>
          ?<br />
          This action cannot be undone.
        </Typography>

        {/* Confirm button */}
        <AdxButton
          fullWidth
          variant="contained"
          onClick={onConfirm}
          sx={{
            mt: '8px',
            backgroundColor: '#F3BF3A',
            color: 'text.primary',
            fontWeight: 600,
            fontSize: '14px',
            borderRadius: '50px',
            py: '14px',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#e6b02e', boxShadow: 'none' },
          }}
        >
          Confirm
        </AdxButton>

        {/* Cancel */}
        <Typography
          onClick={onClose}
          sx={{
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '14px',
            color: 'text.primary',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Cancel
        </Typography>
      </Box>
    </Dialog>
  )
}

export default DeleteAnnouncementModal